module.exports = __webpack_public_path__ + "img/defaultAvatar.12ddd299.svg";